var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBidding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_426",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.275 17.5001H15.675V17.4251L11.55 13.0501L11.575 12.9751H11.825C12.725 12.9751 13.4708 12.7001 14.0625 12.1501C14.6542 11.6001 15.0167 10.9585 15.15 10.2251H16.15V9.05012H15.125C15.075 8.80012 14.9875 8.56262 14.8625 8.33762C14.7375 8.11262 14.5833 7.89179 14.4 7.67512H16.15V6.50012H7.85V7.92512H11.75C12.1833 7.92512 12.5375 8.03346 12.8125 8.25012C13.0875 8.46679 13.275 8.73346 13.375 9.05012H7.85V10.2251H13.4C13.3 10.5585 13.1083 10.846 12.825 11.0876C12.5417 11.3293 12.1583 11.4501 11.675 11.4501H9.175V13.0501L13.275 17.5001ZM12 22.0001C10.6167 22.0001 9.31667 21.7376 8.1 21.2126C6.88333 20.6876 5.825 19.9751 4.925 19.0751C4.025 18.1751 3.3125 17.1168 2.7875 15.9001C2.2625 14.6835 2 13.3835 2 12.0001C2 10.6168 2.2625 9.31679 2.7875 8.10012C3.3125 6.88346 4.025 5.82512 4.925 4.92512C5.825 4.02512 6.88333 3.31262 8.1 2.78762C9.31667 2.26262 10.6167 2.00012 12 2.00012C13.3833 2.00012 14.6833 2.26262 15.9 2.78762C17.1167 3.31262 18.175 4.02512 19.075 4.92512C19.975 5.82512 20.6875 6.88346 21.2125 8.10012C21.7375 9.31679 22 10.6168 22 12.0001C22 13.3835 21.7375 14.6835 21.2125 15.9001C20.6875 17.1168 19.975 18.1751 19.075 19.0751C18.175 19.9751 17.1167 20.6876 15.9 21.2126C14.6833 21.7376 13.3833 22.0001 12 22.0001ZM12 20.0001C14.2333 20.0001 16.125 19.2251 17.675 17.6751C19.225 16.1251 20 14.2335 20 12.0001C20 9.76679 19.225 7.87512 17.675 6.32512C16.125 4.77512 14.2333 4.00012 12 4.00012C9.76667 4.00012 7.875 4.77512 6.325 6.32512C4.775 7.87512 4 9.76679 4 12.0001C4 14.2335 4.775 16.1251 6.325 17.6751C7.875 19.2251 9.76667 20.0001 12 20.0001Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidding);
export default __webpack_public_path__ + "static/media/bidding.81bfaee107f0d50ccf213d130eadec26.svg";
export { ForwardRef as ReactComponent };